// src/components/AppLayout.jsx
import React, { useState, useEffect } from 'react';
import {
  Box,
  IconButton,
  useTheme,
  alpha,
  useMediaQuery,
  LinearProgress,
} from '@mui/material';
import {

  Search,
  Menu as MenuIcon,
 
} from '@mui/icons-material';
import MobileAppBar from './headers/MobileAppBar';
import Sidebar from './appbars/Sidebar';
import MobileDrawer from './appbars/MobileDrawer';
import DesktopHeader from './headers/DesktopHeader';
import ProfileMenu from './headers/ProfileMenu';
import MobileBottonNav from './bottonNav/MobileBottonNav';
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from '../pages/authentication/AuthContext';
import OnboardingGuide from '../components/onboarding/OnboardingGuide';

const AppLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.down('lg'));
  const { user, logout } = useAuth();
  const location = useLocation();
  const [isNavigating, setIsNavigating] = useState(false);
  
  const [selectedNavItem, setSelectedNavItem] = useState(0);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
  const [notificationsCount, setNotificationsCount] = useState(3);

  useEffect(() => {
    setIsNavigating(true);
    const timer = setTimeout(() => setIsNavigating(false), 600);
    return () => clearTimeout(timer);
  }, [location.pathname]);



  const handleProfileMenuOpen = (event) => {
    setProfileMenuAnchor(event.currentTarget);
  };


   const handleProfileMenuClose = () => {
    setProfileMenuAnchor(null);
  };

  const toggleMobileDrawer = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100vw',           // Full viewport width
        minHeight: '100vh',       // At least full height
        maxHeight: '100vh',       // Prevent overflow beyond viewport
        overflow: 'hidden',       // Stop this and body from scrolling
        bgcolor: theme.palette.background.default,
      }}
    >
      {/* Desktop/Tablet Sidebar */}
      {!isMobile && <Sidebar />}

      {/* Mobile Drawer */}
      {isMobile && <MobileDrawer toggleMobileDrawer={toggleMobileDrawer} mobileDrawerOpen={mobileDrawerOpen}  />}

      {/* Mobile App Bar */}
      {isMobile && <MobileAppBar toggleMobileDrawer={toggleMobileDrawer} handleProfileMenuOpen={handleProfileMenuOpen} />}

      {/* Main Content Area */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          height: '100vh', // Changed from minHeight to fixed height
          overflow: 'hidden', // Prevent this container from scrolling
          // Remove paddingTop and paddingBottom - handle spacing differently
        }}
      >
        {/* Desktop Header */}
        {!isMobile && <DesktopHeader handleProfileMenuOpen={handleProfileMenuOpen} 
           />}

        {/* Page Content */}
        <Box
          sx={{
            flex: 1,
            // Fixed padding that works for all screen sizes
            p: { xs: 1, sm: 1, md: 0 },
            bgcolor: theme.palette.background.default,
            position: 'relative',
            overflow: 'hidden', // This container shouldn't scroll
            display: 'flex',
            flexDirection: 'column',
            // Ensure proper spacing from fixed elements
            mt: isMobile ? 'calc(64px + env(safe-area-inset-top))' : 0, // Top margin for mobile app bar + status bar
            mb: isMobile ? 'calc(70px + env(safe-area-inset-bottom))' : 0, // Bottom margin for mobile bottom nav + home indicator
            // Calculate exact available height
            height: isMobile
              ? 'calc(100vh - 64px - env(safe-area-inset-top) - 70px - env(safe-area-inset-bottom))' // Mobile: subtract AppBar + safe areas + BottomNav
              : 'calc(100vh - 64px)', // Desktop: subtract only header
          }}
        >
          {/* Navigation loading indicator */}
          {isNavigating && (
            <LinearProgress
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                zIndex: theme.zIndex.appBar + 2,
                height: '3px',
              }}
            />
          )}

          {/* This is where the scrollable content will be */}
          <Box
            sx={{
              flex: 1,
              overflow: 'auto',
              // Ensure content is properly centered
              width: '100%',
              mx: 'auto', // Center horizontally
              // Custom scrollbar for better UX
              '&::-webkit-scrollbar': {
                width: '6px',
              },
              '&::-webkit-scrollbar-track': {
                background: 'transparent',
              },
              '&::-webkit-scrollbar-thumb': {
                background: alpha(theme.palette.text.secondary, 0.3),
                borderRadius: '3px',
                '&:hover': {
                  background: alpha(theme.palette.text.secondary, 0.5),
                }
              }
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>

      {/* Mobile Bottom Navigation */}
      {isMobile && (
        <MobileBottonNav 
          toggleMobileDrawer={toggleMobileDrawer}
          sx={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: theme.zIndex.appBar + 1
          }}
        />
      )}

      {/* Profile Menu */}
      <ProfileMenu handleProfileMenuClose={handleProfileMenuClose} profileMenuAnchor={profileMenuAnchor} logout={logout}/>

      {/* First-time onboarding guide */}
      <OnboardingGuide />

      {/* Floating Action Elements for Mobile */}
      {isMobile && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 100,
            right: 20,
            zIndex: theme.zIndex.fab
          }}
        >
          
        </Box>
      )}
    </Box>
  );
};

export default AppLayout;